import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs, updateDoc, doc } from "firebase/firestore";
import "./viewapplication.css";


import jsPDF from 'jspdf';

function ViewApplication() {
  const [submits, setSubmits] = useState([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchSubmits = async () => {
      const user = auth.currentUser;
      if (!user) {
        setLoading(false);
        return;
      }

      const userEmail = user.email;
      const submissionRef = collection(db, "formSubmissions");
      const q = query(submissionRef, where("email", "==", userEmail));

      try {
        const querySnapshot = await getDocs(q);
        const submissionList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSubmits(submissionList);
      } catch (error) {
        console.error("Error fetching submissions:", error);
      }

      setLoading(false);
    };

    fetchSubmits();
  }, []);





   // Add this function to update status in Firestore
   const updateStatus = async (submissionId, newStatus) => {
    try {
      await updateDoc(doc(db, "formSubmissions", submissionId), {
        status: newStatus,
        updatedAt: new Date()
      });
      
      // Update local state to reflect changes immediately
      setSubmits(submits.map(sub => 
        sub.id === submissionId ? { ...sub, status: newStatus } : sub
      ));
      
      alert(`Status updated to ${newStatus}`);
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status");
    }
  };


  // ✅ Function to generate Exam Application PDF
  const generateExamApplication = (submission) => {
    const docPdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5", // A5 size
    });
  
    // ------------------ Logo ------------------
    const logo = "/round-logo.png";
    docPdf.addImage(logo, "PNG", 10, 10, 25, 25);
  
    // ------------------ Institute Header ------------------
    docPdf.setFont("times", "bold");
    docPdf.setFontSize(14);
    docPdf.text("EYE CARE INSTITUTE", 70, 20, { align: "center" });
  
    docPdf.setFontSize(12);
    docPdf.text("College of Optometry & Vision Science", 70, 27, { align: "center" });
  
    docPdf.setFont("times", "normal");
    docPdf.setFontSize(12);
    docPdf.text("932, Maradana Road, Colombo 08", 70, 34, { align: "center" });
    docPdf.text("Tel: 011 268 2277 / 077 344 0937", 70, 40, { align: "center" });
  
    // Separator Line
    docPdf.setLineWidth(0.5);
    docPdf.line(10, 45, 140, 45);
  
    // ------------------ Title ------------------
    docPdf.setFont("times", "bold");
    docPdf.setFontSize(13);
    docPdf.text("EXAM ADMISSION", 70, 55, { align: "center" });
  
    // ------------------ Student Details ------------------
    docPdf.setFontSize(12);
  
    let y = 70;
  
    // ✅ Safely format Firestore Timestamp
    let appliedDate = "";
    if (submission.submittedAt?.seconds) {
      appliedDate = new Date(submission.submittedAt.seconds * 1000).toLocaleDateString();
    } else if (submission.submittedAt) {
      appliedDate = new Date(submission.submittedAt).toLocaleDateString();
    }
  
    const details = [
       { label: "Exam Applied Date", value: appliedDate || "" }, // ✅ now string
      { label: "Name", value: submission.name || "" },
      { label: "Course", value: submission.course || "" },
      { label: "Module", value: submission.moduleName || "" },
      { label: "NIC / Passport", value: submission.nicPassportNo || "" },
      { label: "Contact No", value: submission.contactNo || "" },
      { label: "Email", value: submission.email || "" },
     
    ];
  
    details.forEach((item) => {
      // Label bold
      docPdf.setFont("times", "bold");
      docPdf.text(`${item.label}:`, 15, y);
  
      // Value normal
      docPdf.setFont("times", "normal");
      docPdf.text(String(item.value), 55, y); // force string
  
      // Separator line
      y += 6;
      docPdf.setLineWidth(0.2);
      docPdf.line(15, y, 165, y);
      y += 4;
    });
  
  
  
  docPdf.setFontSize(10);
  docPdf.setFont("times", "italic");
  docPdf.text("This is a system-generated exam admission.", 70, 145, {
    align: "center",
  });
    // Save PDF
    docPdf.save(`Exam_Application_${submission.name || "student"}.pdf`);
  };



  return (
    <>
      <section className="hero">
        <div className="hero-image">
          <img src="/round-logo.png" alt="conference" />
        </div>
        <div className="hero-content">
          <h1>Eye Care Institute</h1>
          <p>
            Welcome to Eye Care Institute.
            Enhance your learning experience with personalized courses, resources,
            and tools designed to foster excellence in eye care education.
          </p>
        </div>
      </section>


      <div className="submissions-container">
    <table className="submission-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>module</th>
          <th>NIC/Passport No</th>
          <th>Email</th>
          <th>Contact</th>
          <th>Status</th>
          <th>Submitted At</th>
          <th>Fee Type</th>
          <th>Application File</th>
          <th>Payment Slip</th>
          <th>Exam Application</th>
  
        </tr>
      </thead>
      <tbody>
        {submits.map((submission) => (
          <tr key={submission.id} className="submission-row">
            <td data-label="Name">{submission.name}</td>
            <td data-label="Module">{submission.moduleName}</td>
            <td data-label="NIC/Passport">{submission.nicPassportNo}</td>
            <td data-label="Email">{submission.email}</td>
            <td data-label="Contact">{submission.contactNo}</td>
            <td data-label="Status">
              <span className={`status-badge ${submission.status?.toLowerCase() || 'pending'}`}>
                {submission.status || 'Pending'}
              </span>
            </td>
            <td data-label="Submitted At">
              {submission.submittedAt?.toDate().toLocaleString()}
            </td>
            <td data-label="Fee Type">{submission.feeType}</td>
            <td data-label="Application File">
              <a 
                href={submission.applicationFileUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="file-link"
                title={`Download application: ${submission.applicationFileName}`}
              >
                <span className="file-icon">📝</span> Application
              </a>
            </td>
            <td data-label="Payment Slip">
              <a 
                href={submission.paymentSlipUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="file-link"
                title={`Download payment: ${submission.paymentFileName}`}
              >
                <span className="file-icon">💳</span> Payment
              </a>
            </td>
    
         
          {/* ✅ Exam Application Button */}
           <td>
              {/* ✅ Render button only if feeType is Exam (case-insensitive) */}
              {submission.feeType?.toLowerCase() === "exam" && (
                <button
                  onClick={() => generateExamApplication(submission)}
                  className="btn-exam-download"
                >
                   📥 Exam Application
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {loading && (
      <div className="loading-indicator">
        <div className="spinner"></div>
        <p>Loading submissions...</p>
      </div>
    )}
    
    {!loading && submits.length === 0 && (
      <div className="empty-state">
        <img src="/empty-folder.png" alt="No submissions" />
        <h3>No submissions found</h3>
        <p>There are currently no submissions to display.</p>
      </div>
    )}
  </div>






    </>
  );
}

export default ViewApplication;
